// [ICON_IMPORTS_START]
import React from 'react';
import { AccessibilityHidden, AccessibilityClickableDiv } from '@skillz/accessibility';
import userSVG from "./svgs/user.svg";
import backSVG from "./svgs/back.svg";
import XSvg from "./svgs/x.svg";
import profileSVG from "./svgs/profile.svg";
import profilePurpleSVG from "./svgs/profilePurple.svg";
import closeSVG from "./svgs/close.svg";
import downSVG from "./svgs/down.svg";
import aiMonthSVG from "./svgs/aiMonth.svg";
import Tooltip from '../tooltip/Tooltip';
import calendarSVG from "./svgs/calendar.svg";
import myLearningSVG from "./svgs/myLearning.svg";
import arrowsSVG from "./svgs/arrows.svg";
import discoverySVG from "./svgs/discovery.svg";
import plusLearningSVG from "./svgs/plusLearning.svg";
import professionalDevelopmentSVG from "./svgs/professionalDevelopment.svg";
import messagesSVG from "./svgs/messages.svg";
import usefulToolsSVG from "./svgs/usefulTools.svg";
import bgtSVG from "./svgs/bgt.svg";
import bgtTasksSVG from "./svgs/bgtTasks.svg";
import bgtLearningSpacesSVG from "./svgs/bgtLearningSpaces.svg";
import bagrutSVG from "./svgs/bagrut.svg";
import settingSvg from "./svgs/settings.svg";
import editSVG from "./svgs/edit.svg";
import editElementSVG from "./svgs/editElement.svg";
import radarSVG from "./svgs/radar.svg";
import homeSVG from "./svgs/home.svg";
import realisticIsraelSVG from "./svgs/realisticIsrael.svg";
import taskSVG from "./svgs/task.svg"
import tasksSVG from "./svgs/tasks.svg"
import calendarWithoutNumbersSVG from "./svgs/calendarWithoutNumbers.svg"
import accessibilitySVG from "./svgs/accessibility.svg"
import supportSVG from "./svgs/Support.svg"
import closeCircleSVG from "./svgs/closeCircle.svg"
import shortcutsSVG from "./svgs/shortcuts.svg"
import finalProjectsSVG from "./svgs/finalProjects.svg"
import timerIconSVG from "./svgs/timerIcon.svg"
import timerSVG from "./svgs/timer.svg"
import focusIconSVG from "./svgs/focusIcon.svg"
import approvedIconSVG from "./svgs/approvedIcon.svg"
import archiveBookIconSVG from "./svgs/archiveBookIcon.svg"
import presentationIconSVG from "./svgs/presentionIcon.svg"
import finalProgectWidgetIconSVG from "./svgs/finalProjectWidget.svg"
import directInboxSVG from "./svgs/directInbox.svg"
import classes from './Icon.module.css';
import heritagePathsSVG from "./svgs/heritagePaths.svg"
import sendSVG from "./svgs/send.svg"
import deleteSVG from "./svgs/delete.svg"
import downloadSVG from "./svgs/download.svg"
import arrowTriangularSVG from "./svgs/arrowTriangular.svg"
import addCircleSVG from "./svgs/addCircle.svg"
import addCircleButtonSVG from "./svgs/addCircleButton.svg"
import addImgSVG from "./svgs/addImg.svg"
import championshipSVG from "./svgs/championship.svg"
import googleMeetSVG from "./svgs/googleMeet.svg"
import copySVG from "./svgs/copy.svg"
import tehudaSVG from "./svgs/tehuda.svg"
import heroismSVG from "./svgs/heroism.svg"
import clearSearchSVG from "./svgs/clearSearch.svg"
import filterSVG from "./svgs/filter.svg"
import discoverySearchSVG from "./svgs/discoverySearch.svg"
import confirmSVG from "./svgs/confirm.svg"
import managerDashboardSVG from "./svgs/managerDashboard.svg"
import checkmarkSVG from "./svgs/checkmark.svg"
import caretDownSVG from "./svgs/caretDown.svg"
import closeCircleFilledSVG from "./svgs/closeCircleFilled.svg"
import galleryAddSVG from "./svgs/galleryAdd.svg"
import infoCircleSVG from "./svgs/infoCircle.svg"
import lockSVG from "./svgs/lock.svg"
import searchSVG from "./svgs/search.svg"
import scheduleZoomOutSVG from "./svgs/scheduleZoomOut.svg";
import scheduleZoomInSVG from "./svgs/scheduleZoomIn.svg";
import scheduleRotateSVG from "./svgs/scheduleRotate.svg";
import scheduleEditImageSVG from "./svgs/scheduleEditImage.svg";
import scheduleTabPersonalSVG from "./svgs/scheduleTabPersonal.svg";
import scheduleTabClassSVG from "./svgs/scheduleTabClass.svg";
import scheduleFileInfoSVG from "./svgs/scheduleFileInfo.svg";
import openImgSVG from "./svgs/openImg.svg";
import plusCircleSVG from "./svgs/plusCircle.svg";
import editCircleSVG from "./svgs/editCircle.svg";
import openInNewTabSVG from "./svgs/openInNewTab.svg";
import starSVG from "./svgs/star.svg";
import starOutlineSVG from "./svgs/starOutline.svg";
import checkSquareSVG from "./svgs/checkSquare.svg";
import alertTriangleSVG from "./svgs/alertTriangle.svg";
import googleSVG from "./svgs/gmail.svg";
import microsoftSVG from "./svgs/microsoft.svg";
import faqSVG from "./svgs/faq.svg"
import botSVG from "./svgs/bot.svg";
import tabScrollChevronSVG from "./svgs/tabScrollChevron.svg";
import financialEducationSVG from "./svgs/financialEducation.svg";

const iconComponents = {
    user: userSVG,
    back: backSVG,
    profile: profileSVG,
    profilePurple: profilePurpleSVG,
    close: closeSVG,
    x: XSvg,
    down: downSVG,
    aiMonth: aiMonthSVG,
    calendar: calendarSVG,
    calendarWithoutNumbers: calendarWithoutNumbersSVG,
    myLearning: myLearningSVG,
    arrows: arrowsSVG,
    discovery: discoverySVG,
    plusLearning: plusLearningSVG,
    professionalDevelopment: professionalDevelopmentSVG,
    messages: messagesSVG,
    usefulTools: usefulToolsSVG,
    bgt: bgtSVG,
    bgtTasks: bgtTasksSVG,
    bgtLearningSpaces: bgtLearningSpacesSVG,
    bagrut: bagrutSVG,
    settings: settingSvg,
    edit: editSVG,
    editElement: editElementSVG,
    radar: radarSVG,
    home: homeSVG,
    realisticIsrael: realisticIsraelSVG,
    task: taskSVG,
    tasks: tasksSVG,
    support: supportSVG,
    accessibility: accessibilitySVG,
    closeCircle: closeCircleSVG,
    shortcuts: shortcutsSVG,
    heritagePaths: heritagePathsSVG,
    send: sendSVG,
    delete: deleteSVG,
    download: downloadSVG,
    arrowTriangular: arrowTriangularSVG,
    finalProjects: finalProjectsSVG,
    timerIcon: timerIconSVG,
    timer: timerSVG,
    focusIcon: focusIconSVG,
    approvedIcon: approvedIconSVG,
    presentationIcon: presentationIconSVG,
    archiveBookIcon: archiveBookIconSVG,
    finalProgectWidgetIcon: finalProgectWidgetIconSVG,
    directInbox: directInboxSVG,
    addCircle:addCircleSVG,
    addCircleButton:addCircleButtonSVG,
    addImg: addImgSVG,
    championship: championshipSVG,
    googleMeet: googleMeetSVG,
    copy: copySVG,
    tehuda: tehudaSVG,
    heroism: heroismSVG,
    clearSearch: clearSearchSVG,
    filter: filterSVG,
    confirm: confirmSVG,
    managerDashboard: managerDashboardSVG,
    checkmark: checkmarkSVG,
    caretDown: caretDownSVG,
    closeCircleFilled: closeCircleFilledSVG,
    galleryAdd: galleryAddSVG,
    infoCircle: infoCircleSVG,
    lock: lockSVG,
    search: searchSVG,
    discoverySearch: discoverySearchSVG,
    scheduleZoomOut: scheduleZoomOutSVG,
    scheduleZoomIn: scheduleZoomInSVG,
    scheduleRotate: scheduleRotateSVG,
    scheduleEditImage: scheduleEditImageSVG,
    scheduleTabPersonal: scheduleTabPersonalSVG,
    scheduleTabClass: scheduleTabClassSVG,
    scheduleFileInfo: scheduleFileInfoSVG,
    openImg: openImgSVG,
    plusCircle: plusCircleSVG,
    editCircle: editCircleSVG,
    openInNewTab: openInNewTabSVG,
    star: starSVG,
    starOutline: starOutlineSVG,
    checkSquare: checkSquareSVG,
    alertTriangle: alertTriangleSVG,
    google: googleSVG,
    microsoft: microsoftSVG,
    faq: faqSVG,
    bot: botSVG,
    tabScrollChevron: tabScrollChevronSVG,
    financialEducation: financialEducationSVG,
};

const Icon = ({ color, name, size = "32px", width, height, onClick, className, tooltip, accessibilityDescription }) => {
    const IconComponent = iconComponents[name];
    const iconStyle = { color: color && color, stroke: color && color, width: width ?? size, height: height ?? size };

    const renderIcon = () => {
        return (
            onClick ?
                <AccessibilityClickableDiv onClick={onClick} accessibilityDescription={accessibilityDescription}>
                    <AccessibilityHidden>
                        <div
                            className={`${classes.Icon} ${className}`}
                            dangerouslySetInnerHTML={{ __html: IconComponent }}
                            style={iconStyle}
                        />
                    </AccessibilityHidden>
                </AccessibilityClickableDiv>
                :
                <AccessibilityHidden>
                    <div
                        className={`${classes.Icon} ${className}`}
                        dangerouslySetInnerHTML={{ __html: IconComponent }}
                        style={iconStyle}
                    />
                </AccessibilityHidden>
            )
    };

    return (
        tooltip ?
            <Tooltip text={tooltip}>
                {renderIcon()}
            </Tooltip>
            :
            renderIcon()
    )
};

export default Icon;


